<template>
  <div :class="cardClass">
    <slot />
  </div>
</template>

<script setup>
import { computed } from 'vue'

/**
 * ContentCard - コンテンツカードコンポーネント (Molecule)
 *
 * Atomsを組み合わせて作る、意味のあるコンテンツ表示カードです。
 *
 * 責務:
 * - コンテンツの統一されたカード表示
 * - 適切な余白とボーダーの提供
 * - 子コンテンツの配置管理
 * - UIの描画に専念（ロジックは持たない）
 */

const props = defineProps({
  /**
   * カードのパディング
   * 'sm': 小
   * 'md': 標準
   * 'lg': 大
   */
  padding: {
    type: String,
    default: 'md',
    validator: (value) => {
      return ['sm', 'md', 'lg'].includes(value)
    }
  },
  /**
   * 背景色の有無
   */
  background: {
    type: Boolean,
    default: true
  },
  /**
   * ボーダーの有無
   */
  border: {
    type: Boolean,
    default: true
  }
})

const cardClass = computed(() => {
  const paddingClasses = {
    sm: 'p-3',
    md: 'p-4',
    lg: 'p-6'
  }

  const classes = [paddingClasses[props.padding]]

  if (props.background) {
    classes.push('bg-white')
  }

  if (props.border) {
    classes.push('border', 'border-gray-200', 'rounded-lg')
  }

  return classes
})
</script>

<style scoped>
.p-3 {
  padding: 0.75rem;
}

.p-4 {
  padding: 1rem;
}

.p-6 {
  padding: 1.5rem;
}

.bg-white {
  background-color: #ffffff;
}

.border {
  border-width: 1px;
}

.border-gray-200 {
  border-color: #e5e7eb;
}

.rounded-lg {
  border-radius: 0.5rem;
}
</style>
